import React, { useEffect, useRef } from "react";

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertProps,
  AlertTitle
} from "@chakra-ui/react";

import { AppError } from "@/jenesys-types/errors";

import { generateTestId } from "@/util/testIds";

export interface ErrorAlertProps extends AlertProps {
  error: AppError;
  title?: string;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  error,
  title,
  ...rest
}) => {
  const errorRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (errorRef?.current) {
      errorRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <Alert
      ref={errorRef}
      status="error"
      p={2}
      {...rest}
      mt={2}
      mb={2}
      data-testid={generateTestId.status("error", "alert")}
    >
      <AlertIcon data-testid={generateTestId.icon("error")} />
      {!!title && (
        <AlertTitle data-testid={generateTestId.status("error", "title")}>
          {title}
        </AlertTitle>
      )}
      <AlertDescription
        whiteSpace="pre-line"
        data-testid={generateTestId.status("error", "message")}
      >
        {error.message}
      </AlertDescription>
    </Alert>
  );
};
